import AHttpService from '@d-services/a-http-service/a-http-service';
import URLS from '@d-shared/urls/urls';

class SearchService extends AHttpService {
  async getSearchResults(term) {
    const url = URLS.api.search.replace('<term>', term);
    const response = await this._http.get(url);
    return response.data;
  }
}

export default new SearchService();
